/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SocialPlatformType } from './SocialPlatformType';
import {
    SocialPlatformTypeFromJSON,
    SocialPlatformTypeFromJSONTyped,
    SocialPlatformTypeToJSON,
    SocialPlatformTypeToJSONTyped,
} from './SocialPlatformType';

/**
 * Connected social platform for a surface
 * @export
 * @interface SurfaceSocialConnection
 */
export interface SurfaceSocialConnection {
    /**
     * Subdocument id (assigned by Mongo) — required for clients that need to address an individual social connection by id (edit/delete).
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    _id?: string;
    /**
     * 
     * @type {SocialPlatformType}
     * @memberof SurfaceSocialConnection
     */
    platform?: SocialPlatformType;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    platformUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    profileUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    profileImageUrl?: string;
    /**
     * Banner/header image URL
     * @type {string}
     * @memberof SurfaceSocialConnection
     */
    bannerImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceSocialConnection
     */
    followers?: number;
    /**
     * Games played on this platform
     * @type {Array<string>}
     * @memberof SurfaceSocialConnection
     */
    gamesPlayed?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceSocialConnection
     */
    connected?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceSocialConnection
     */
    connectedAt?: number;
}



/**
 * Check if a given object implements the SurfaceSocialConnection interface.
 */
export function instanceOfSurfaceSocialConnection(value: object): value is SurfaceSocialConnection {
    return true;
}

export function SurfaceSocialConnectionFromJSON(json: any): SurfaceSocialConnection {
    return SurfaceSocialConnectionFromJSONTyped(json, false);
}

export function SurfaceSocialConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceSocialConnection {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'platform': json['platform'] == null ? undefined : SocialPlatformTypeFromJSON(json['platform']),
        'platformUserId': json['platformUserId'] == null ? undefined : json['platformUserId'],
        'username': json['username'] == null ? undefined : json['username'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'profileUrl': json['profileUrl'] == null ? undefined : json['profileUrl'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'bannerImageUrl': json['bannerImageUrl'] == null ? undefined : json['bannerImageUrl'],
        'followers': json['followers'] == null ? undefined : json['followers'],
        'gamesPlayed': json['gamesPlayed'] == null ? undefined : json['gamesPlayed'],
        'connected': json['connected'] == null ? undefined : json['connected'],
        'connectedAt': json['connectedAt'] == null ? undefined : json['connectedAt'],
    };
}

export function SurfaceSocialConnectionToJSON(json: any): SurfaceSocialConnection {
    return SurfaceSocialConnectionToJSONTyped(json, false);
}

export function SurfaceSocialConnectionToJSONTyped(value?: SurfaceSocialConnection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'platform': SocialPlatformTypeToJSON(value['platform']),
        'platformUserId': value['platformUserId'],
        'username': value['username'],
        'displayName': value['displayName'],
        'profileUrl': value['profileUrl'],
        'profileImageUrl': value['profileImageUrl'],
        'bannerImageUrl': value['bannerImageUrl'],
        'followers': value['followers'],
        'gamesPlayed': value['gamesPlayed'],
        'connected': value['connected'],
        'connectedAt': value['connectedAt'],
    };
}

